document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-drawer]');
  document.querySelectorAll('[data-drawer-open]').forEach((button) => button.addEventListener('click', () => { drawer?.classList.add('is-open'); document.body.classList.add('canopy-lock'); }));
  document.querySelectorAll('[data-drawer-close]').forEach((button) => button.addEventListener('click', () => { drawer?.classList.remove('is-open'); document.body.classList.remove('canopy-lock'); }));

  // Product gallery: switch the main image when a thumbnail is clicked.
  // Shopify's image_tag outputs a srcset; if only `src` is changed, the browser
  // can keep rendering the old image selected from that srcset. Remove it first.
  const initProductGallery = (root = document) => {
    root.querySelectorAll('[data-product-stage]').forEach((stage) => {
      if (stage.dataset.canopyGalleryReady === 'true') return;
      stage.dataset.canopyGalleryReady = 'true';

      const mediaWrap = stage.closest('.canopy-product-media-wrap');
      const stageImage = stage.querySelector('.canopy-product-stage__image');
      if (!mediaWrap || !stageImage) return;

      const thumbs = [...mediaWrap.querySelectorAll('[data-product-thumb]')];
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (event) => {
          event.preventDefault();
          const nextSrc = thumb.dataset.imageSrc;
          if (!nextSrc) return;

          stageImage.removeAttribute('srcset');
          stageImage.removeAttribute('sizes');
          stageImage.src = nextSrc;
          stageImage.alt = thumb.dataset.imageAlt || '';

          thumbs.forEach((item) => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-pressed', 'true');
        });
      });
    });
  };

  initProductGallery();
  document.addEventListener('shopify:section:load', (event) => initProductGallery(event.target));

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelector('[data-qty-minus]')?.addEventListener('click', () => { input.value = Math.max(0, Number(input.value || 0) - 1); });
    control.querySelector('[data-qty-plus]')?.addEventListener('click', () => { input.value = Number(input.value || 0) + 1; });
  });
});

// CANOPY Hero Slider
(() => {
  const initHero = (hero) => {
    if (!hero || hero.dataset.canopyHeroReady === 'true') return;
    hero.dataset.canopyHeroReady = 'true';
    const slides = [...hero.querySelectorAll('[data-canopy-hero-slide]')];
    const dots = [...hero.querySelectorAll('[data-canopy-hero-dot]')];
    if (slides.length < 2) return;
    let current = 0;
    let timer = null;
    const speed = Math.max(3000, Number(hero.dataset.speed) || 6000);
    const autoplay = hero.dataset.autoplay === 'true';
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === current); slide.setAttribute('aria-hidden', i === current ? 'false' : 'true'); });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    };
    const stop = () => { if (timer) window.clearInterval(timer); timer = null; };
    const start = () => { stop(); if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(current + 1), speed); };
    hero.querySelector('[data-canopy-hero-prev]')?.addEventListener('click', () => { show(current - 1); start(); });
    hero.querySelector('[data-canopy-hero-next]')?.addEventListener('click', () => { show(current + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.canopyHeroDot)); start(); }));
    let touchX = null;
    hero.addEventListener('touchstart', (e) => { touchX = e.touches[0]?.clientX ?? null; stop(); }, {passive:true});
    hero.addEventListener('touchend', (e) => { if (touchX === null) return; const dx = (e.changedTouches[0]?.clientX ?? touchX) - touchX; if (Math.abs(dx) > 45) show(current + (dx < 0 ? 1 : -1)); touchX = null; start(); }, {passive:true});
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start);
    show(0); start();
  };
  const initAll = () => document.querySelectorAll('[data-canopy-hero]').forEach(initHero);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

// CANOPY Team Carousel v10.1
(() => {
  const initTeamCarousel = (root = document) => {
    root.querySelectorAll('[data-canopy-team-carousel]').forEach((carousel) => {
      if (carousel.dataset.canopyTeamReady === 'true') return;
      carousel.dataset.canopyTeamReady = 'true';

      const track = carousel.querySelector('[data-canopy-team-track]');
      const prev = carousel.querySelector('[data-canopy-team-prev]');
      const next = carousel.querySelector('[data-canopy-team-next]');
      if (!track || (!prev && !next)) return;

      const cards = [...track.querySelectorAll('.canopy-team-card')];
      if (!cards.length) return;

      const getStep = () => {
        const card = cards[0];
        const style = getComputedStyle(track);
        const gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 4;
      };

      prev?.addEventListener('click', () => track.scrollBy({ left: -getStep(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: getStep(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      requestAnimationFrame(update);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTeamCarousel());
  } else {
    initTeamCarousel();
  }
  document.addEventListener('shopify:section:load', (event) => initTeamCarousel(event.target));
})();
